import { render } from "./AddStudent.vue?vue&type=template&id=af36a0b2&scoped=true"
import script from "./AddStudent.vue?vue&type=script&lang=js"
export * from "./AddStudent.vue?vue&type=script&lang=js"

import "./AddStudent.vue?vue&type=style&index=0&id=af36a0b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af36a0b2"]])

export default __exports__